import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalSetter = () => {
  const location = useLocation();

  useEffect(() => {
    const canonicalHref = `https://tournoispadel.fr${location.pathname}`;

    let canonicalLink = document.querySelector("link[rel='canonical']");

    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    canonicalLink.setAttribute('href', canonicalHref);
  }, [location.pathname]);

  return null;
};

export default CanonicalSetter;
